/** @internal */
export const OP_FAIL = "Fail" as const

/** @internal */
export type OP_FAIL = typeof OP_FAIL

/** @internal */
export const OP_DIE = "Die" as const

/** @internal */
export type OP_DIE = typeof OP_DIE

/** @internal */
export const OP_INTERRUPT = "Interrupt" as const

/** @internal */
export type OP_INTERRUPT = typeof OP_INTERRUPT

/** @internal */
export const OP_SUCCEED = "Succeed" as const

/** @internal */
export type OP_SUCCEED = typeof OP_SUCCEED

/** @internal */
export const OP_RETRY = "Retry" as const

/** @internal */
export type OP_RETRY = typeof OP_RETRY
